export default __webpack_public_path__ + "static/media/logo-light.750c73ac.png";